import { render } from "./logs-workspace.html?vue&type=template&id=781f7754&scoped=true&ts=true"
import script from "./logs-workspace.ts?vue&type=script&lang=ts"
export * from "./logs-workspace.ts?vue&type=script&lang=ts"

import "./logs-workspace.scss?vue&type=style&index=0&id=781f7754&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781f7754"]])

export default __exports__